import { 
  useSaveNotesMutation, 
  useCreateNoteMutation, 
  useUpdateNoteMutation, 
  useDeleteNoteMutation 
} from '../notesApi';
import { enqueueSnackbar } from 'notistack';
import { TOAST_ERROR, TOAST_SUCCESS } from '../../../utils/constants';
import i18next from 'i18next';

export const useNotesActions = () => {
  const [saveNotesTrigger] = useSaveNotesMutation();
  const [createNoteTrigger] = useCreateNoteMutation();
  const [updateNoteTrigger] = useUpdateNoteMutation();
  const [deleteNoteTrigger] = useDeleteNoteMutation();

  const saveNotes = async ({ pageModuleId, text }) => {
    try {
      const result = await saveNotesTrigger({ pageModuleId, text }).unwrap();
      enqueueSnackbar(i18next.t('notes.saved'), { variant: TOAST_SUCCESS });
      return result;
    } catch (err) {
      const errorMessage = err?.error?.response?.errMsg || 'Failed to save note';
      enqueueSnackbar(errorMessage, { variant: TOAST_ERROR });
      throw err;
    }
  };

  const createNote = async ({ pageId, text }) => {
    try {
      const result = await createNoteTrigger({ pageId, text }).unwrap();
      enqueueSnackbar(i18next.t('notes.added'), { variant: TOAST_SUCCESS });
      return result;
    } catch (err) {
      const errorMessage = err?.error?.response?.errMsg || 'Failed to create note';
      enqueueSnackbar(errorMessage, { variant: TOAST_ERROR });
      throw err;
    }
  };

  const updateNote = async ({ noteId, pageId, text }) => {
    try {
      const result = await updateNoteTrigger({ noteId, pageId, text }).unwrap();
      return result;
    } catch (err) {
      const errorMessage = err?.error?.response?.errMsg || 'Failed to update note';
      enqueueSnackbar(errorMessage, { variant: TOAST_ERROR });
      throw err;
    }
  };

  const deleteNote = async ({ pageId, noteId }) => {
    try {
      const result = await deleteNoteTrigger({ pageId, noteId }).unwrap();
      enqueueSnackbar(i18next.t('notes.deleted'), { variant: TOAST_SUCCESS });
      return result;
    } catch (err) {
      const errorMessage = err?.error?.response?.errMsg || 'Failed to delete note';
      enqueueSnackbar(errorMessage, { variant: TOAST_ERROR });
      throw err;
    }
  };

  return {
    saveNotes,
    createNote,
    updateNote,
    deleteNote,
  };
};
